// 要素(gps-marker)の画面中心にズーム移動
export function focusOnPoint(Viewer, zoomLevel = 1.0, markerId = "gps-marker") {
  if (!Viewer) return;
  const elem = document.getElementById(markerId);
  if (!elem) return;

  const cr = elem.getBoundingClientRect();
  const v = Viewer.getValue();
  const x = (cr.x + cr.width / 2 - v.e) / v.a;
  const y = (cr.y + cr.height / 2 - v.f) / v.a;
  Viewer.setPointOnViewerCenter(x, y, zoomLevel);
}
